import { render, staticRenderFns } from "./TransportationLocationUpdateListItem.vue.vue?vue&type=template&id=dfc53fc0"
import script from "./TransportationLocationUpdateListItem.vue.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransportationLocationUpdateListItem.vue.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports